import { useState } from 'react';

import {
  InputSearch,
  ScrollArea,
  ScrollBar,
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
} from '@app-evolution-cms/element-ui';

import { NavFooter } from './nav-footer';
import { NavHeader } from './nav-header';
import { NavModules } from './nav-modules';

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const [searchValue, setSearchValue] = useState('');

  return (
    <Sidebar className="select-none" {...props}>
      <SidebarHeader>
        <NavHeader />
      </SidebarHeader>
      <SidebarContent className="min-h-0">
        <div className="mx-0.5 p-2 pb-0">
          <InputSearch
            id="PER-navigation-sidebarContent-filter-input"
            sizesx="sm"
            placeholder="Buscar módulo por id, nombre o permiso"
            queryParam="module-filter"
            value={searchValue}
            onChange={(event) => setSearchValue(event.target.value)}
          />
        </div>

        <ScrollArea className="h-full w-full">
          <NavModules searchValue={searchValue} />
          <ScrollBar orientation="vertical" />
        </ScrollArea>
      </SidebarContent>
      <SidebarFooter>
        <NavFooter />
      </SidebarFooter>
    </Sidebar>
  );
}
